import { useI18n } from "@/api/i18n";
import { cn } from "@/libs/cn";
import { COLOR_TRANSITION, FOCUS_RING } from "./primitives";

const I18N = "taxonomy.sector" as const;

/**
 * «Aggiungi un secondo settore · consigliato». From 320 px «· consigliato»
 * never falls on a line of its own: the last word of the label and the tag
 * travel together inside a `whitespace-nowrap` span (AC32).
 */
export const AddSecondButton = (props: {
  onClick: () => void;
  class?: string;
}) => {
  const { t } = useI18n();
  const split = () => {
    const label = t(`${I18N}.addSecond`);
    const at = label.lastIndexOf(" ");
    return at < 0
      ? { head: "", last: label }
      : { head: label.slice(0, at + 1), last: label.slice(at + 1) };
  };

  return (
    <button
      type="button"
      onClick={() => props.onClick()}
      class={cn(
        "flex min-h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed border-ring/50 bg-ring/5 px-3 py-2 text-sm font-medium text-ring hover:border-ring hover:bg-ring/10",
        COLOR_TRANSITION,
        FOCUS_RING,
        props.class,
      )}
    >
      <i class="ph ph-plus shrink-0" aria-hidden="true" />
      <span class="text-center">
        {split().head}
        <span class="whitespace-nowrap">
          {split().last} <span class="text-xs">{t(`${I18N}.recommended`)}</span>
        </span>
      </span>
    </button>
  );
};
